module.exports = __webpack_public_path__ + "img/laravel.ca51de4c.svg";